import React, {Children, createContext, useEffect, useReducer} from 'react';
import ZooPassLocalStateData from "../Data/ZooPassLocalStateData";
import ZooPassLocalStateUtility from "../Utilities/ZooPassLocalStateUtility";
import ZooPassStepDataUtility from "../Utilities/ZooPassStepDataUtility";
import { MemberDataDto } from '../Data/MemberDataDto';

export type ZooPassAnswersState = {
    answersData: ZooPassLocalStateData | null;
    answersLoading: boolean;
};

type ZooPassAnswersAction = 
    | { type: "init" }
    | { type: "reset" }
    | { type: "setAnswers"; value: ZooPassLocalStateData }
    | { type: "setFormData"; value: MemberDataDto }

const initialState: IZooPassAnswersContext = {
    updateContext: (action: ZooPassAnswersAction )=> {
    },
    answersData: ZooPassLocalStateUtility.ReadLocalState(), 
    answersLoading: true
}

export interface IZooPassAnswersContext extends ZooPassAnswersState
{
    updateContext: React.Dispatch<ZooPassAnswersAction>
}

function reducer(state: ZooPassAnswersState = initialState, action: ZooPassAnswersAction) {
    switch (action.type) {
        case "init":
            return {
                ...state,
                answersLoading: true
            }
        case "reset":
            return {
                ...state,
                answersData: null,
                answersLoading: true
            }
        case "setAnswers":
            return {
                ...state,
                answersData: ZooPassStepDataUtility.FixDataForStep(action.value),
                answersLoading: false,
            }
        case "setFormData":
            if (state.answersData != null) {
                let updatedData = {
                    ...state.answersData,
                    formData: action.value
                };
                return {
                    ...state,
                    answersData: ZooPassStepDataUtility.FixDataForStep(updatedData),
                    answersLoading: false,
                }
            }
    }
}


export const ZooPassAppAnswersContext = React.createContext<IZooPassAnswersContext>(initialState);

export const ZooPassAppAnswersContextProvider = ({children} : any) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    useEffect(() => {
        const initialize = () => {
            dispatch({type: 'init'});
            let loadedData = ZooPassLocalStateUtility.ReadLocalState()
            if(loadedData == null) {
                loadedData = ZooPassLocalStateUtility.SetInitialState();
            }
            dispatch({type: 'setAnswers', value: loadedData});
        }
        initialize();
        
        const handlePageShow = (event) => {
            if (event.persisted) {
                // Reset state manually
                initialize();
            }
        };
        window.addEventListener('pageshow', handlePageShow);
        return () => window.removeEventListener('pageshow', handlePageShow);
    }, []);

    return <ZooPassAppAnswersContext.Provider value={{...state!, updateContext:dispatch}}>
        {children}
    </ZooPassAppAnswersContext.Provider>
}
export const useZooPassAppAnswersContext = () => React.useContext(ZooPassAppAnswersContext);